module.exports = __webpack_public_path__ + "static/media/33.d9c1b9b6.jpg";